<div class="deleted-div">
  <span class="material-icons">
    block
  </span>        
  <span class="deleted-message">
    {{ deletedText }}
  </span>
</div>
